var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_145",
    "data-name": "Group 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4196",
    "data-name": "Rectangle 4196",
    width: 43,
    height: 32,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M41.656,26.666H5.375V1.333A1.338,1.338,0,0,0,4.032,0H1.344A1.338,1.338,0,0,0,0,1.332H0v28A2.677,2.677,0,0,0,2.687,32H41.656A1.338,1.338,0,0,0,43,30.668h0V28a1.338,1.338,0,0,0-1.343-1.333h0Z",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M27.951,21.333h3.225a1.152,1.152,0,0,0,1.075-1.067V9.066A1.152,1.152,0,0,0,31.176,8H27.951a1.152,1.152,0,0,0-1.075,1.067v11.2a1.152,1.152,0,0,0,1.075,1.066",
    fill: "#ffeba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M36.013,21.333h3.225a1.152,1.152,0,0,0,1.075-1.067V1.066A1.151,1.151,0,0,0,39.239,0H36.014a1.152,1.152,0,0,0-1.075,1.067v19.2a1.152,1.152,0,0,0,1.075,1.066Z",
    fill: "#56af91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M11.825,21.333h3.226a1.152,1.152,0,0,0,1.075-1.067V14.4a1.152,1.152,0,0,0-1.075-1.067H11.826A1.152,1.152,0,0,0,10.751,14.4v5.867a1.152,1.152,0,0,0,1.075,1.066Z",
    fill: "#3f8598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M19.888,21.333h3.225a1.152,1.152,0,0,0,1.075-1.067V3.733a1.152,1.152,0,0,0-1.075-1.067H19.889a1.152,1.152,0,0,0-1.075,1.067V20.267a1.152,1.152,0,0,0,1.075,1.066Z",
    fill: "#e8758c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.93beb2e9b714f4637efa7bd0d8ee9c5c.svg";
export { ForwardRef as ReactComponent };